const Spanish = {
    es: {

        // O2MATIC ADMINISTRATOR
        "O2maticAdministrator": "Administrador de O2matic",
        "ReturnToO2maticAdministrator": "Volver al administrador de O2matic",
        "ReturnToAdminpage": "Volver a la página de administración",
                // oximeter
        "AddOximeter": "Agregar oxímetro de pulso",
        "AddOximeterToWhitelist": "Agregar oxímetro de pulso a lista blanca",
        "AddAnotherOximeter": "Agregar otro oxímetro de pulso",
                // metadata
        "Metadata": "Metadatos",
        "AddMetadata": "Agregar metadatos",
        "AddMoreMetadata": "Agregar más metadatos",
        "SelectMetadata": "Seleccionar metadatos",
        "MetadataValue": "Valor de metadatos",
        "MetadataValueHasBeenAddded": "El valor de metadatos ha sido agregado",
        "AddMetadataValue": "Agregar valor de metadatos",
        "CreateMetadataValue": "Crear valor de metadatos",
        "MetadataId": "Identificación del metadatos", //added by KAC
        "MetadataValueId": "Identificación del valor de metadatos", //added by KAC
                // notification
        "Notification": "Notificación",
        "AddNotification": "Agregar notificación",
        "AddNotificationText": "Agrega aquí una notificación que se mostrará a todos los usuarios.",
        "WriteMessageHere": "Escribe mensaje aquí",
        "NotificationActive": "Notificación activa",
                // sessions from storage
        "DownloadSessionFromStorage": "Descargar sesiones del almacenamiento",
        "GetSessions": "Descargar sesiones",
        
        // PATIENT PAGE
                // data and charts
        "Help": "Ayuda",
        "WifiUnkown": "Si el paciente tiene wifi instalado en casa",
        "Wifi": "Wi-Fi",
        "HasWifi": {
                "Field": "¿El paciente tiene wifi en casa?",
                "TableField": "Tiene wifi"
        },
        "DownloadDataFiles": "Descargar archivos de datos",
        "SelectFileFormat": "Seleccionar formato de archivo",
        "ConfirmToDownload": "Confirmar para descargar",
        "individualPdfFiles": "archivos PDF individuales",


        // TREATMENT
        // "TreatmentErrorMessages": {
        //         "NameMaxCharacters": "Máximo 20 caracteres",
        //         "NameNotEmpty": "No puede estar vacío",
        //         "NameCantContain": "El nombre solo puede contener %{chars} y números %{numbers}",
        // },

        // APP LICENSES PAGE

        // LOCATIONS PAGE
        "ServiceProviderDefault": "Proveedor de servicios predeterminado",
        "ServiceProviderName": "Nombre del proveedor de servicios",
        "ServiceproviderName": "Nombre del proveedor de servicios",
        "ServiceProviderValue": "Valor del proveedor de servicios",
        "ServiceproviderValue": "Valor del proveedor de servicios",
        "HealthcareProviderDefault": "Proveedor de atención médica predeterminado",
        "HealthcareProviderName": "Nombre del proveedor de atención médica",
        "HealthcareproviderName": "Nombre del proveedor de atención médica",
        "HealthcareProviderValue": "Valor del proveedor de atención médica",
        "HealthcareproviderValue": "Valor del proveedor de atención médica",
        "ProviderValueLabel": "Teléfono (máximo %{maxCount} números)",
        "LocationNoTreatments": "No hay tratamientos disponibles para esta ubicación",
        "UnableToCompletePatient": "No será posible crear al paciente",

        
        // USERS PAGE

        // DEVICE PAGE

        "ShowEventsDescription": "Mostrar eventos con gravedad",
        "NofityHealthcareMessage": "Evento(s) del tipo 'Notificar al proveedor de atención médica' ocurrieron dentro del período de tiempo seleccionado.",
        
        // INSTALLER
        "ServiceOverview": "Resumen de servicio",
        "InstallerLookupExplanation": "Busque pacientes y dispositivos utilizando uno o más de los criterios de búsqueda a continuación.",
        "PatientDeleted": "Paciente eliminado",
        "NoPatientOnDevice": "No hay paciente en el dispositivo",
        "NewPatient": "Nuevo paciente",
        "NewTreatment": "Nuevo tratamiento",
        "PatientNotPaired": "Paciente no emparejado",
        "PatientUnpaired": "Paciente desemparejado",
        "NoData": "Sin datos",
        "OK": "OK",
        "NoSessionDataSinceTimestamp": "Sin datos de sesión desde %{timestamp}",
        "NoSessionDataSinceDays": "Sin datos de sesión en los últimos %{days} día(s)",
        "NoSessionDataSinceDaysName": "Sin datos de sesión en los últimos __ día(s)",
        "PatientUnauthorized": "Paciente no autorizado",
        "DeviceUnauthorized": "Dispositivo no autorizado",
        "LocationMismatch": "Desajuste de ubicación",
        "NoSessionDataSince": "Sin datos de sesión desde",
        "NewSwUpdateAvailable": "Nueva actualización de SW disponible",
        "NewFwUpdateAvailable": "Nueva actualización de FW disponible",
        "DeviceSwVersion": "Versión de software del dispositivo (SW)",
        "DeviceFwVersion": "Versión de firmware del dispositivo (FW)",
        "SoftwareUpToDate": "El software está actualizado",
        "SWFWUpToDate": "SW/F está actualizado",
        "SWServiceUpToDateAva": "Actualización de SW/Servicio disponible",
        "SWUpdateAvailable": "SW disponible", //Actualización de SW disponible
        "FWUpdateAvailable": "FW disponible", //Actualización de FW disponible
        "DeviceIsUpToDate": "El dispositivo está actualizado",
        "HasNoWareVersion": "No tiene %{ware} asignado",  
        "ClearFilters": "Limpiar filtros",   
        "ClearSearch": "Limpiar búsqueda",

        "RemarkTableHeaders": {
                "Remark": "Observación",
                "Explanation": "Explicación",
                "RecommendedAction": "Acción recomendada"
        },

        "UpdateFilters": {
                "SWUpdateAvailable": "Actualización de software disponible", // Actualización de SW disponible
                "ServiceAvailable": "Servicio recomendado", // Anteriormente actualización de FW disponible
                "DeviceIsUpToDate": "Dispositivo actualizado"
                },
        "UpdateLegend": {
                "Sw": "Actualización de software disponible",
                "Fw": "El dispositivo tiene una actualización de %{ware} disponible. Por favor, contacte a O2matic",
                "Service": "Servicio recomendado"
                },
        "RemarkHierExplainer": {
                "Header": "Explicaciones de comentarios",
                "Body1": "Los comentarios se refieren tanto a dispositivos como a pacientes y se actualizan automáticamente.",
                "Body2": "Se enumeran en orden de prioridad de mayor a menor.",
                "Body3": "Solo se muestra el comentario con mayor prioridad en la tabla de resumen."
        },
        "RemarkExplainers": {
                "NewPatient": { 
                        "Explainer": "El paciente aún no ha sido instalado en ningún dispositivo HOT.", 
                        "RecommendedAction": "Instale al paciente en el dispositivo." 
                },
                "NoSessionDataSinceDays": { 
                        "Explainer": "Sin datos de sesión en los últimos __ día(s)", 
                        "RecommendedAction": "Si es necesario, verifique que la configuración del paciente esté conectada correctamente." 
                },
                "PatientDeleted": { 
                        "Explainer": "El paciente ha sido eliminado. Si un dispositivo aún tiene al paciente instalado, se mostrará en la tabla.", 
                        "RecommendedAction": "Recupere el dispositivo del paciente y restablezca el dispositivo a los valores de fábrica." 
                },
                "NoData": { 
                        "Explainer": "No se han recibido datos de sesiones de este paciente.", 
                        "RecommendedAction": "Si es necesario, verifique que la configuración del paciente esté conectada correctamente." 
                },
                "PatientUnpaired": { 
                        "Explainer": "El paciente ha sido eliminado del último dispositivo utilizado.", 
                        "RecommendedAction": "Reinstale al paciente en un dispositivo para garantizar que la transferencia de datos esté habilitada."
                }, 
                "NewTreatment": { 
                        "Explainer": "El tratamiento prescrito ha sido actualizado, pero aún no se ha instalado en el dispositivo.", 
                        "RecommendedAction": "Actualice el dispositivo reinstalando al paciente." 
                },
                "OK": { 
                        "Explainer": "No se identificaron observaciones.", 
                        "RecommendedAction": "" 
                },
                "NoPatientOnDevice": { 
                        "Explainer": "Actualmente no hay ningún paciente instalado en el dispositivo. En espera de la instalación del paciente.", 
                        "RecommendedAction": "" 
                },
                "PatientUnauthorized": {
                        "Explainer": "El usuario no está autorizado para ver la información del paciente. El paciente está en una ubicación fuera de su autorización.",
                        "RecommendedAction": ""
                },
                "DeviceUnauthorized": {
                        "Explainer": "El usuario no está autorizado para ver la información del dispositivo. El dispositivo está en una ubicación fuera de su autorización.",
                        "RecommendedAction": ""
                },
                "LocationMismatch": {
                        "Explainer": "El paciente y el dispositivo no están asignados a la misma ubicación.",
                        "RecommendedAction": "Cambiar la ubicación del paciente o del dispositivo."
                }
        },
        "IBackupFlow": {
                "Explainer": {
                        "TreatmentPage": "Ingrese el flujo que el paciente debe usar en una emergencia, como una falla de energía, problemas técnicos con la fuente de oxígeno o el dispositivo HOT. El flujo de respaldo debe estar en un nivel que proporcione al paciente el tratamiento de oxígeno necesario hasta que el proveedor de servicios pueda asistirlo.",
                        "PatientPage": "El flujo de oxígeno de respaldo independiente del HOT que el paciente debe usar en una emergencia, como una falla de energía, problemas técnicos con la fuente de oxígeno o el dispositivo HOT. El nivel del flujo de respaldo debe proporcionar al paciente el tratamiento de oxígeno necesario hasta que el proveedor de servicios pueda asistirlo."
                }
        },
        "SWServiceUpToDateAva": "SW/Servicio disponible",

        // PRODUCTION - TRACE
        "Assembled": "Ensamblado",
        "AtRepairO2matic": "En reparación O2matic",
        "Packaged": "Empaquetado",
        "Prod QA Approved": "Aprobado por QA de producción",
        "ReadyForInvestigation": "Listo para investigación",
        "ReadyForO2maticApproval": "Listo para aprobación de O2matic",
        "ReadyForRepair": "Listo para reparación",
        "ReadyForTesting": "Listo para pruebas",
        "ReleasedForSale": "Liberado para la venta",
        "ClinicalInvestigation": "Investigación clínica",
        "SCRAPPED": "DESECHADO",
        "Shipped": "Enviado",
        "Tested": "Probado",
        "Received": "Recibido",

                // pro steps
        "ContainsProDevice": "El paquete contiene el dispositivo PRO",
        "Sensor": "Sensor",
        "ContainsSensor": "El paquete contiene el sensor",
        "ContainsUserManual": "El paquete contiene el manual de usuario",
        "MasterPin": "Pin maestro",
        "ContainsMasterPin": "El paquete contiene el pin maestro",
        "OxygenOutputAdapter": "Adaptador de salida de oxígeno",
        "ContainsOxygenOutputAdapter": "El paquete contiene el adaptador de salida de oxígeno",
                // test
        "TestProcedureFollowed":"Procedimiento de prueba seguido",
        "TestProcedureFollowedText":"Confirme que se siguió el procedimiento de prueba",
        "TurningOnTheDevice":"Encendido del dispositivo",
        "TurningOnTheDeviceText":"Verifique que el dispositivo se enciende",
        "DeviceStatus":"Estado del dispositivo",
        "DeviceStatusText":"Verifique el estado del dispositivo",
        "BatteryMode":"Modo de batería",
        "BatteryModeText":"Verifique el modo de batería",
        "PulseOximeter":"Oxímetro de pulso",
        "PulseOximeterText":"Verifique el oxímetro de pulso",
        "AlarmSpeaker1":"Altavoz de alarma 1",
        "AlarmSpeaker1Text":"Verifique el altavoz de alarma 1",
        "AlarmSpeaker2":"Altavoz de alarma 2",
        "AlarmSpeaker2Text":"Verifique el altavoz de alarma 2",
        "OxygenFlow":"Flujo de oxígeno",
        "OxygenFlowText":"Verifique el flujo de oxígeno",
        "OxygenLeakage":"Fuga de oxígeno",
        "OxygenLeakageText":"Verifique si hay fuga de oxígeno",
        "FirmwareVersion":"Versión del firmware",
        "FirmwareVersionText":"Seleccione la versión del firmware",
        "SoftwareVersion":"Versión del software",
        "SoftwareVersionText":"Seleccione la versión del software",
        "ProcessorSerialNumber":"Número de serie del procesador (PUID)",
        "ProcessorSerialNumberText":"Ingrese el número de serie del procesador (PUID)",
        "ZeroFlow":"Flujo cero",
        "ZeroFlowText":"Verifique el dispositivo a 0 l/min",
        "VisualInspection":"Inspección visual",
        "VisualInspectionText":"Verifique si el dispositivo presenta daños o defectos visibles",
        "MacAddressText":"Ingrese la dirección MAC",
        "BluetoothConnection":"Conexión Bluetooth",
        "BluetoothConnectionText":"Verifique la conexión Bluetooth",
                // QA
                "ProductionQAAproveMessage":"Seleccionar lote(s)/dispositivo(s) para ser aprobados en control de calidad de producción",
                "O2maticQaApproveText": "¿Está seguro de que desea aprobar este dispositivo con control de calidad de O2matic?",
                "ProductionQAApprovedReady":"Dispositivos aprobados por control de calidad de producción listos para la aprobación de control de calidad de O2matic",
                "O2maticTestedReady":"Dispositivos probados por O2matic listos para la aprobación de control de calidad de O2matic",

        // LOGS PAGE

        // INFORMATION PAGE
        "Guide": "Guía",

        // MAIN PAGE

        // GENERAL
        "Optional": "Opcional",
        "Explaination": "Explicación",
        "RecommendedAction": "Acción recomendada",

                // units and time
        "Monday": "Lunes",
        "Tuesday": "Martes",
        "Wednesday": "Miércoles",
        "Thursday": "Jueves",
        "Friday": "Viernes",
        "Saturday": "Sábado",
        "Sunday": "Domingo",

        "High": "Alto",
        "Medium": "Medio",
        "Low": "Bajo",


                // country and language
        "Country-DK": "Dinamarca",
        "Country-DE": "Alemania",
        "Country-ES": "España",
        "Country-VN": "Vietnam",
        "Country-UM": "Islas Ultramarinas Menores de Estados Unidos",
        "Country-AE": "Emiratos Ýrabes Unidos",
        "Country-UA": "Ucrania",
        "Country-TR": "Turquía",
        "Country-TH": "Tailandia",
        "Country-TW": "Taiwán",
        "Country-CH": "Suiza",
        "Country-LK": "Sri Lanka",
        "Country-SI": "Eslovenia",
        "Country-SK": "Eslovaquia",
        "Country-SG": "Singapur",
        "Country-RS": "Serbia",
        "Country-SA": "Arabia Saudita",
        "Country-RU": "Rusia",
        "Country-RO": "Rumania",
        "Country-QA": "Catar",
        "Country-PR": "Puerto Rico",
        "Country-PT": "Portugal",
        "Country-PL": "Polonia",
        "Country-PH": "Filipinas",
        "Country-PE": "Perú",
        "Country-PA": "Panamá",
        "Country-OM": "Omán",
        "Country-NZ": "Nueva Zelanda",
        "Country-NL": "Países Bajos",
        "Country-MC": "Mónaco",
        "Country-MX": "México",
        "Country-MT": "Malta",
        "Country-MY": "Malasia",
        "Country-MK": "Macedonia del Norte",
        "Country-LU": "Luxemburgo",
        "Country-LI": "Liechtenstein",
        "Country-LV": "Letonia",
        "Country-KW": "Kuwait",
        "Country-KR": "Corea del Sur",
        "Country-KZ": "Kazajistán",
        "Country-JO": "Jordania",
        "Country-JP": "Japón",
        "Country-IT": "Italia",
        "Country-IE": "Irlanda",
        "Country-ID": "Indonesia",
        "Country-IN": "India",
        "Country-IS": "Islandia",
        "Country-HU": "Hungría",
        "Country-HK": "Hong Kong",
        "Country-GR": "Grecia",
        "Country-FR": "Francia",
        "Country-FI": "Finlandia",
        "Country-FO": "Islas Feroe",
        "Country-EE": "Estonia",
        "Country-EG": "Egipto",
        "Country-EC": "Ecuador",
        "Country-CZ": "República Checa",
        "Country-CY": "Chipre",
        "Country-HR": "Croacia",
        "Country-CR": "Costa Rica",
        "Country-CN": "China",
        "Country-CA": "Canadá",
        "Country-BG": "Bulgaria",
        "Country-BR": "Brasil",
        "Country-BV": "Isla Bouvet",
        "Country-BA": "Bosnia y Herzegovina",
        "Country-BE": "Bélgica",
        "Country-BY": "Bielorrusia",
        "Country-BD": "Bangladesh",
        "Country-BH": "Baréin",
        "Country-AZ": "Azerbaiyán",
        "Country-AT": "Austria",
        "Country-AU": "Australia",
        "Country-AM": "Armenia",
        "Country-AR": "Argentina",
        "Country-DZ": "Argelia",
        "Country-AL": "Albania",
        "Country-GB": "Reino Unido",
        "Country-SE": "Suecia",
        "Country-LT": "Lituania",
        "Country-US": "Estados Unidos de América",
        "Country-NO": "Noruega",

        "Language-it": "Italiano",
        "Language-en": "Inglés",
        "Language-da": "Danesa",
        "Language-de": "Alemana",
        "Language-es": "Española",
        
        
        // order these..........................
        "MacAddress": "MAC",
        "Devices": "Dispositivos",
        "Active": "Activa",
        "License": "Licencia de aplicación",
        "AddAppLicense": "Añadir licencia de aplicación",
        "AddAppLicenses": "Agregar licencias de aplicaciones",
        "Address": "Dirección",
        "AddressLine": "Nombre de la calle, no",
        "AdjustingPhase": "Fase de ajuste",
        "AllowedLtRange": "Flujo de O2 permitido sin oxímetro de pulso",
        "AllowedStRange": "Flujo de O2 permitido con oxímetro de pulso",
        "AllowedTimeWithin": "Tiempo permitido dentro",
        "AppLicenseDetails": "Detalles de la licencia de la aplicación",
        "AppLicenseName": "Nombre de la licencia de la aplicación",
        "AppLicenses": "Licencias de aplicaciones",
        "AppLicensesOverview": "Resumen de licencias de aplicaciones",
        //"Birthday": "Cumpleaños",
        "Birthdate": "Fecha de nacimiento",

        

        "DateOfBirth": "Fecha de nacimiento",
        "BPM": "BPM",
        "bpm": "bpm",
        "and": "y",

        "InvalidDate": "Fecha no válida",
        "InvalidValue": "Valor no válido",
        "Installer": "Instalador",
        "AddLocation": "Agregar ubicación",

        "ChangeSecret": "Cambiar secreto",
        "ChartHelp": "Ayuda del gráfico",
        "ChartPreview": "Vista previa del gráfico",
        "City": "Ciudad",
        "ClientId": "Identificación del cliente",
        "ClientSecret": "Secreta del cliente",
        "Close": "Cerca",
        "Contacts": "Contactos",
        "Country": "País",
        "Created": "Creada",
        "CreateLocation": "Crear ubicación",
        "AddPatient": "Crear paciente",
        "AddPatientText": "Aquí puede crear un nuevo paciente. Todos los campos marcados con * son obligatorios.",
        "AddTreatmentProfile": "Crear perfil de tratamiento",
        "AddTreatmentProfileText": "Aquí puede crear un nuevo perfil de tratamiento. Todos los campos marcados con * son obligatorios.",
        "CustomIdentifier": "Identificador personalizado",
        "Customize": "Personalizar",
        "Customizing": "Personalización",
        // "Delete": "Eliminar",
        "DeleteAppLicenseText": "¿Realmente desea eliminar esta licencia?",
        "Disable": "Deshabilitar",
        "Disabled": "Desactivada",
        "DisableTreatmentProfileText": "Realmente desea deshabilitar este perfil de tratamiento?",
        "EditLocation": "Editar ubicación",
        "EditPatient": "Editar paciente",
        "EditPatientText": "Aquí puede editar un paciente. Todos los campos marcados con * son obligatorios.",
        "Edit": "Editar",
        "Enable": "Habilitar",
        "Enabled": "Activada",
        "EnableTreatmentProfileText": "¿Realmente desea habilitar este perfil de tratamiento?",
        "Fast": "Rápida",
        "Female": "Femenina",
        "female": "Femenina",
        "LastMeasuredO2Flow": "Último medido flujo de O2",
        "LastMeasuredPulse": "Último medido pulso",
        "PulseFinal": "Medición final del pulso",
        "LastMeasuredSpO2": "Último medido SpO2",
        "SpO2Final": "Medición final de SpO2",
        "FirstName": "Nombre de pila",
        "FlowResponse": "Respuesta de flujo",
        "FlowResponseRate": "Tasa de respuesta de flujo",
        //"FlowResponseExplanation": "Qué tan rápido el dispositivo cambia el flujo en la fase de ajuste",
        "From": "De",
        "Gender": "Género",
        "GoBackTo": "Regresa a",
        "HealthcareProvider": "Proveedor de atención sanitaria", // UPDATE
        "HealthcareProviderName": "Nombre del proveedor de atención médica", // UPDATE
        "HomePage": "Página de inicio",
        "Id": "ID",
        "Identifier": "Identificador",
        "IdentifierType": "Tipo de identificador",
        "IdentifierValue": "Valor del identificador",
        "InitialO2Flow": "Flujo inicial de O2",
        "InitialPulse": "Pulso inicial",
        "InitialSpO2": "SpO2 inicial",
        "InitialValues": "Valores iniciales",
        "ServiceProvider": "Proveedor de servicio",
        "ServiceProviderName": "Nombre del proveedor de servicios",
        "Language": "Idioma",
        "LastName": "Apellido",
        "Loading": "Cargando...",
        "Dmr": "DMR",
        "Sw": "Versión del software",
        "Fw": "Versión de firmware",
        "LocationDetails": "Detalles de ubicación",
        "Locations": "Ubicaciones",
        "LoggingOut": "Estás siendo desconectado.",
        "LoginHelpText": "Póngase en contacto con su administrador para obtener las credenciales de inicio de sesión",
        "LoginPageHeader": "Página de demostración",
        "Training": "Formación",
        "LogOut": "Cerrar sesión",
        "LowFlowCompatibilityWarning": "Es posible que no se admita la elección de un flujo mínimo inferior a 0,5 en la configuración del paciente (es decir, concentrador)",
        "LPM": "l/min",
        "O2RangeWithoutPOExplanation": "Rango de flujo de O2 en l/min cuando el oxímetro de pulso NO está en el dedo",
        "O2RangeWithPOExplanation": "Rango de flujo de O2 en l/min cuando el oxímetro de pulso está en el dedo.",
        "O2RangeWithoutPO": "Rango de flujo de O2 sin oxímetro de pulso",
        "O2RangeWithPO": "Rango de flujo de O2 con oxímetro de pulso",
        "Male": "Masculina",
        "male": "Masculina",
        "Name": "Nombre",
        "NextIntervention": "Próxima intervención",
        "Normal": "Normal",
        "NotFoundPage": "La página no se puede encontrar",
        "NoTreatments": "No hay tratamientos",
        "Search": "Búsqueda",
        "PatientNotAssignedToDevice": "El paciente actualmente no está asignado a ningún dispositivo",

        "O2": "O2",
        "O2Flow": "Flujo de O2",
        "BackupFlow": "Flujo de respaldo",

        "O2FlowRange": "Rango de flujo de O2",
        "O2maticId": "Identificación O2matic",
        "ParentLocation": "Ubicación de los padres",
        "PatientDashboard": "Tablero del paciente",
        "PatientDashboardText": "Aquí puede obtener una descripción general de las medidas tomadas y los tratamientos administrados por el dispositivo del paciente.",
        "PatientData": "Datos del paciente",
        "PatientId": "ID del paciente",
        "PatientInformation": "Información del paciente",
        "PatientLookup": "Búsqueda de pacientes",
        "PatientSearch": "Buscar pacientes",
        "PatientLookupExplanation": "Busque pacientes utilizando uno o más de los criterios de búsqueda siguientes.",
        "PatientLookupExplanation2": "Haga clic en un paciente en la tabla para abrir la página del paciente.",
        "Patients": "Pacientes",
        "PhoneNumber": "Número de teléfono",
        "PleaseConfirm": "Estas segura",
        "PostalCode": "Código postal",
        "Pulse": "Legumbres", // to be changes to pulso?
        "PulseAverage": "Pulso promedio",
        "PulseRange": "Rango de pulso",
        "SelectRoles": "Seleccionar funciones",
        "SelectSessionExplanation": "Haga clic en una sesión específica en la tabla para ver los datos detallados de la sesión.",
        "SelectTreatment": "Seleccionar perfil de tratamiento",
        "ShortTermLength": "Fracción de tiempo con oxímetro de pulso",
        "ShortTermExplanation": "Cuántos minutos por hora se permite que el flujo de corto plazo esté activo.",
        "SignIn": "Iniciar sesión",
        "HotDeviceEdit": "Editar dispositivo HOT",
        "MinutesPerHour": "Minutos por hora",
        "AlwaysOn": "Siempre encendido",
        "Always": "Siempre",
        "EditDevice": "Editar dispositivo",
        "AlwaysOff": "Siempre apagado",
        "SpO2": "SpO2",
        "SpO2Average": "Promedio de SpO2",
        "SpO2Range": "Rango de SpO2",
        "HotDeviceDetails": "Detalles del dispositivo HOT",
        "ProDeviceDetails": "Detalles del dispositivo PRO",
        "Status": "Estado",
        "AnalysingPhaseExplanation": "Establézcalo en Sí si no desea que los primeros 5 minutos de un tratamiento ajusten automáticamente el flujo", // treatment -> session
        //"StO2RangeExplanation": "Rango de flujo de O2 en l/min cuando el oxímetro de pulso está en el dedo",
        "Submit": "Enviar",
        "SpO2TargetRange": "Objectivo de SpO2", // KAC - check this
        "TargetSpO2RangeExplanation": "Objectivo de SpO2 al fin de la sesión",
        "Title": "Título",
        "AddLog": "Agregar registro",
        "Read": "Leer",
        "Update": "Actualizar",
        "Delete": "Borrar",
        "Download": "Descargar",
        "AnalysingPhaseDescription": "Primeros 5 min de tratamiento con flujo fijo de O2", // treatment -> session
        "To": "A",
        "Yes": "Sí",
        "No": "No",
        "Log": "Registro",
        "Logs": "Registros",
        "AuditorLogs": "Auditor Registros",
        "PatientLogReminder": {
                "ImportantNote": "Nota importante:",
                "Text": "Los registros escritos aquí son visibles tanto para el personal de salud como para el proveedor de servicios."
        },

        "Devices": "Dispositivos",
        "DetailedData": "Datos detallados",
        "HotDevices": "Dispositivos HOT",
        "HotDevice": "Dispositivo HOT",
        "ProDevice": "Dispositivo PRO",
        "ProDevices": "Dispositivos PRO",
        "ProDeviceEdit": "Editar dispositivo PRO",
        "EventLog": "Registros de eventos",
        "DownloadCsv": "Descargar como CSV",
        "DownloadPdf": "Descargar como pdf",
        "Device": "Dispositivo",
        "Treatment": "Tratamiento",
        //"TreatmentDetails": "Detalles del perfil de tratamiento",
        "TreatmentId": "ID de tratamiento",
        "TreatmentInformation": "Información del tratamiento",
        "TreatmentName": "Nombre del tratamiento",
        "Treatments": "Tratamientos",
        "UnauthorizedPage": "No está autorizado para ver esta página.",
        "UntilNextSession": "Hasta la próxima sesión",
        "VeryFast": "Muy rapida",
        "DataRetentionPeriod": "Período de retención de datos",
        "Day": "Día",
        "Days": "Días",
        "Months": "Meses",
        "UserOverview": "Descripción general del usuario",
        "UserDetails": "Detalles de usuario",
        "UserLocation": "Ubicación del usuario",
        "Users": "Usuarias",
        "UserSearch": "Buscar usuarios",
        "UserLookupExplanation": "Buscar usuarios usando uno o más de los siguientes criterios de búsqueda.",
        "UserLookupExplanation1": "Consigue todos los usuarios buscando sin criterios.",
        "UserLookupExplanation2": "Haga clic en un usuario en la tabla para abrir la página del usuario.",
        "Email": "Email",
        "AddRole": "Agregar rol",
        "ModifyRole": "Modificar rol",
        "Role": "Role",
        "Roles": "Roles",
        "RoleLocation": "Ubicación del rol",
        "None": "Ninguna",
        "NotSelected": "No seleccionado",
        "DeletePatientText": "¿Está seguro de que desea eliminar a este paciente? Todos los datos del paciente se perderán",
        "DeletePatientTextWithComponentLink": "El paciente todavía está conectado al dispositivo. Si el dispositivo aún no ha sido recogido, recomendamos recuperar el dispositivo antes de eliminarlo, ya que la dirección del paciente se perderá al eliminarlo.",
        "Back": "Atrás",
        "Continue": "Continuar",
        "Finish": "Finalizar",
        "ClinicalTrial": "Ensayo clínico",
        "DeleteUserText": "La usuaria será eliminada de forma permanente.",
        "DefineSpO2": "Defina un rango aceptable de saturación de SpO2",
        "DefineSpO2Message": "Defina un rango de saturación de SpO2 aceptable según las necesidades del paciente",
        "Lower": "Más bajo",
        "Higher": "Mas alta",
        "ConsiderTheFolowing": "Considera lo siguiente",
        "QuestionType2RespiratoryFailure": "¿Está la paciente en riesgo de insuficiencia respiratoria tipo 2?",
        "QuestionLevelOfActivity": "¿Cuál es el nivel de actividad de los pacientes?",
        "QuestionOxygenSource": "¿Cuánto oxígeno puede proporcionar la fuente de oxígeno?",
        "DefineO2FlowWithPO": "Defina los rangos de flujo de O2 con el oxímetro de pulso encendido",
        "DefineO2FlowWithPOMessage": "Configure el rango de flujo de O2 para cuando el paciente esté conectado al oxímetro de pulso",
        "DefineO2FlowWithOutPO": "Definir rangos de flujo de O2 sin oxímetro de pulso",
        "DefineO2FlowWithOutPOMessage": "El rango de flujo de O2 sin oxímetro de pulso no debe exceder el rango de flujo del rango de flujo de O2 con oxímetro de pulso",
        "DefineFlowResponse": "Seleccione la respuesta de flujo apropiada",
        "DefineFlowResponseMessage": "La configuración de respuesta de flujo cambia la rapidez con la que el dispositivo ajusta el flujo de O2 en función de los signos vitales del paciente.",
        "DefineFixedFlow": "Primeros cinco minutos de tratamiento con flujo fijo", // treatment -> session
        "DefineFixedFlowMessage": "Los primeros fiempos minutos de cada sesión de tratamiento comenzarán con cinco minutos de flujo de O2 fijo. Luego, el dispositivo comenzará a ajustar el flujo.", // treatment -> session
        "Success": "Éxito",
        "BadRequest": "Solicitud incorrecta",
        "Unauthorized": "No autorizado",
        "NotFound": "Extraviada",
        "IntenalServerError": "Error Interno del Servidor",
        "UnknownError": "Error desconocido",
        "Unknown": "Desconocido",
        "SystemLog": "Registro del sistema",
        "NoSessionInSelectedInterval": "No hay sesiones en el intervalo seleccionado",
        "OxygenPrescription": "Prescripción mínima de oxígeno",
        "OxygenPrescriptionExplanation": "Por favor, especifique el número mínimo de horas por día que el paciente debe utilizar la oxigenoterapia.",
        "OxygenPrescriptionUnit": "horas/día",
        "AddUser": "Agregar usuario",
        "validationError_WithoutPoMinIsSmaller": "'Sin oxímetro de pulso' mínimo es menor o igual que 'con oxímetro de pulso' mínimo",
        "validationError_WithoutPoMaxIsBigger": "'Sin oxímetro de pulso' máximo es mayor o igual que 'con oxímetro de pulso' máximo",
        "Action": "Acción",
        "Actions": "Acciones",
        "Domain": "Dominio",
        "LogDomain": "Dominio de registro",
        "TargetObjectId": "ID de objeto de destino",
        "TargetObjectLocation": "Ubicación del objeto de destino",
        "Timestamp": "Marca de tiempo",
        "Time": "Tiempo",
        "UserId": "ID de usuario",
        "Message": "Mensaje",
        "HomeMessage1": "Conecta a los pacientes en tratamiento de oxígeno con sus profesionales de la salud.",
        "HomeMessage2": "Una solución que mejora la seguridad y calidad de vida para los pacientes al mismo tiempo que facilita la carga de trabajo y reduce la necesidad de contacto físico para los profesionales de la salud.",
        "SelectLanguage": "Seleccione el idioma",
        "SelectCountry": "Seleccionar país",
        "SelectLocation": "Seleccionar ubicación",
        "Length": "Longitud",
        "":"",
        "Format": "Formato",
        "Version": "Versión",
        "Select": "Seleccionar",
        "Owner": "Propietario",
        "NewBatch": "Nuevo lote",
        "Production": "Producción",
        "SelectType": "Seleccionar tipo",
        "SelectTags": "Seleccionar etiquetas",
        "AssembleNewDevice":"Ensamblar nuevo dispositivo",
        "Assemble":"Ensamblar",
        "DevicePending": "dispositivos pendientes",
        "Open": "Abrir",
        "Tag": "Etiqueta",
        "Tags": "Etiquetas",
        "SelectDeviceForTestText": "Seleccionar un dispositivo de la tabla para prueba.",
        "SelectDeviceForPackageText": "Seleccionar un dispositivo de la tabla para empaque.",
        "TestingDeviceWithUDSN": "Prueba de dispositivo con UDSN",
        "PackagingDeviceWithUDSN": "Empaquetado de dispositivo con UDSN",
        "QAAprove": "QA aprobar",
        //"QAAproveMessage": "Seleccionar lote(s)/dispositivo(s) para aprobar production QA",
        "ProductionQAAprove":"Production QA aprobar",
        "O2maticQAAprove": "O2matic QA aprobar",
        "Approve": "Aprobar",
        "O2maticQAAproveMessage": "Seleccionar lote(s)/dispositivo(s) para aprobar QA O2matic",
        "O2maticTestedQAAproveMessage": "Seleccione el dispositivo para ser aprobado por QA de O2matic",
        "DeviceWillBeMovedToRepair": "No todos los tests están pasando.",
        "DeviceWillBeMovedToRepairNullTests": "No todos los tests se han superado y no todas las pruebas están completadas.",
        "DeviceToRepair": "El dispositivo será trasladado a reparación.",
        "MetadataNotFilled": "Los metadatos no están correctamente rellenados o faltan valores.",
        "DuplicateEntry": "Entrada duplicada",
        "ContactO2maticToResolve": "Verificar datos, si el problema persiste, contactar a O2matic para resolver el problema",
        "duplicateMAC": "Dirección MAC duplicada",
        "duplicatePrint": "Serie de impresión duplicada",
        "duplicateFlowmeter": "Serie de flujómetro duplicada",
        "duplicateValve": "Serie de válvula duplicada",
        "duplicateOximeter": "Serie de oxímetro de pulso duplicada",
        "ShipperMessage": "Seleccionar lote(s)/dispositivo(s) y ubicación para ser enviados",
        "Repair": "Reparar",
        "RepairOverviewMessage": "Seleccionar dispositivo para ser reparado",
        "RepairDeviceWithUdsn": "Reparando el dispositivo con UDSN",
        "Session": "Sesión",
        "SessionId": "ID de Sesión",
        "LengthOfSession": "Duración de Sesión",
        "Start": "Comienzo",
        "StartOfSession": "Comienzo de sesión",
        "End": "Fin",
        "EndOfSession": "Fin de sesión",
        "Zone": "Zona",

        "Analysing": "Analizando",

        "UTCTimestamp": "Marca de tiempo UTC",
        "l/min": "l/min",
        "min/hour": "min/hora",
        "hour/day": "hora/día",
        "hours/day": "horas/día",
        "hours": "hora",
        "Test": "Prueba",
        "ProductionTest": "Prueba de producción",
        "O2maticTest":"Prueba de O2matic",
        "Package": "Empaque",
        "QA": "QA",
        "Qa": "QA",
        "ProductionQA":"QA de producción",
        "O2maticQA": "QA de O2matic",
        "O2maticqa": "QA de O2matic",
        "Ship": "Enviar",
        "PrintSerial": "Número de serie de impresión",
        "FlowmeterSerial": "Número de serie de flujómetro",
        "ValveSerial": "Número de serie de válvula",
        "OximeterSerial": "Número de serie de oxímetro de pulso",
        "Create": "Crear",

        "SelectOwner": "Seleccionar propietario",
        "OwnerLocationChanged": "El propietario y la ubicación del dispositivo han cambiado",
        "SelectStatus": "Seleccionar estado",
        "ComponentId": "ID componente",
        "Components": "Componentes",
        "SelectLocationFirst": "Seleccione una ubicación primero",
        "Sessions": "Sesiones",
        "Compliance": "Cumplimiento",
        "PatientLog": "Registro del paciente",
        "LogEntry": "Entrada de registro",
        "Patient": "Paciente",
        "User": "Usuario",
        "Added": "Añadido",
        "CreateReport": "Crear informe",
        "ProReportMessage": "Cargue archivos de sesión profesionales y genere el informe. No se guardan ni transfieren datos.",

        "EnableLiveData": "Activar datos en vivo",
        "PauseLiveData":"Pausar datos en vivo",
        "DisableLiveData": "Desactivar datos en vivo",

        "StartTime": "Hora de inicio",
        "EndTime": "Hora de finalización",
        "LastSession": "Última sesión",
        "NextSession": "Próxima sesión",
        "O2FlowTarget": "Objetivo de flujo de O2",
        "O2FlowInitial": "Inicial de flujo de O2",
        "SpO2Initial": "SpO2 inicial",
        "PulseInitial": "Pulso inicial",
        "O2FlowMin": "Mínimo de flujo de O2",
        "O2FlowMax": "Máximo de flujo de O2",
        "PulseMin": "Mínimo de Pulso",
        "PulseMax": "Máximo de Pulso",
        "SpO2Min": "Mínimo de SpO2",
        "SpO2Max": "Máximo de SpO2",
        "O2FlowAverage": "Promedio de flujo de O2",
        "O2FlowStandardDeviation": "Desviación estándar de flujo de O2",
        "PulseStandardDeviation": "Desviación estándar de pulso",
        "SpO2StandardDeviation": "Desviación estándar de SpO2",
        "O2FlowStd": "Desviación estándar de flujo de O2",
        "PulseStd": "Desviación estándar de pulso",
        "SpO2Std": "Desviación estándar de SpO2",
        "Mode": "Modo",
        "Minimum": "Mínimo",
        "Maximum": "Máximo",
        "Average": "Promedio",
        "MODE": "Modo",
        "MINIMUM": "Mínimo",
        "MAXIMUM": "Máximo",
        "AVERAGE": "Promedio",
        "AverageRange": "Rango promedio",
        "TimeSpent": "Tiempo transcurrido",
        "TimeSpent(%)":"Tiempo transcurrido (%)",
        "LengthOfRecordedData": "Longitud de datos grabados",
        "TreatmentProfile": "Perfil de tratamiento",
        "TreatmentProfiles": "Perfiles de tratamiento",
        "GenerateReport": "Generar informe",
        "DownloadCSV": "Descargar CSV",
        "Adjusting": "Ajustando",
        "DownloadReport": "Descargar informe",
        "DaySummary": "Resumen diario de O2matic",
        "DaySummaryDisclaimer": "Nota: Los cálculos utilizados para generar este informe no están validados y no deben utilizarse para evaluar la condición del paciente.",
        "DetailedDataDisclaimerChart": "Los datos detallados de la sesión en este gráfico no están validados y no están destinados a la toma de decisiones clínicas. Por favor, consulte los datos de la sesión antes de tomar decisiones clínicas.",
        "DetailedDataDisclaimerTable": "Las estadísticas detalladas de los datos en esta tabla no están validadas y no están destinadas para la toma de decisiones clínicas. Por favor, consulte los datos de la sesión antes de tomar decisiones clínicas.",
        "DetailedDataDisclaimerTableCsv": "Las estadísticas detalladas de los datos no están validadas y no están destinadas para la toma de decisiones clínicas. Por favor, consulte los datos de la sesión antes de tomar decisiones clínicas.",
        "ImportantNote": "Nota Importante",
        "DetailedDataStatistics":"Estadísticas detalladas de los datos",
        "DetailedDataStatisticsByTreatmentProfile":"Estadísticas detalladas de los datos por perfil de tratamiento",
        "SummaryDate": "Fecha de resumen",
        "Generated": "Generado",
        "DataByTreatmentProfile": "Datos por perfil de tratamiento",


        //"CreateUser": "Crear Usuario",

        "SpO2InAdjustingPhase": "Promedio de SpO2 en fase de Ajuste",
        "TargetO2FlowAtEndOfSession": "Flujo de O2 objetivo al finalizar la sesión",
        "EventType": "Tipo de evento",

        "Error": "Error",
        "ErrorCode": "Código de error %{code}",
        // PRODUCTION - TRACE
        "Packaging": "Embalaje",
        "Chassis": "Chasis",
        "Replace": "Reemplazar",
        "Cancel":"Cancelar",
        "Flowmeter": "Flujómetro",
        "Valve": "Válvula",
        "Print": "Placa de circuitos",
        "Screen": "Pantalla",
        "Oximeter": "Oxímetro de pulso",
        "Hot100Chassis": "Chasis HOT 100",
        "Hot100Print": "Imprimir HOT 100",
        "Hot100Battery": "Batería HOT 100",
        "Hot100Device": "Dispositivo HOT 100",
        "Pro100Device": "Dispositivo PRO 100",
        "ReportCreated": "Reporte creado",
        "OriginalValue": "Valor original",
        "ContainsHotDevice": "El paquete contiene un dispositivo CALIENTE",
        "TechnicalUserManual": "Manual de usuario técnico",
        "ContainsTechnicalUserManual": "El paquete contiene un manual de usuario técnico",
        "InstructionsForUse": "Instrucciones de uso",
        "ContainsInstructionsForUse": "El paquete contiene instrucciones de uso",
        "DeclarationOfConformity": "Declaración de conformidad",
        "ContainsDeclarationOfConformity": "El paquete contiene una declaración de conformidad",
        "PowerSupply": "Fuente de alimentación",
        "ContainsPowerSupply": "El paquete contiene una fuente de alimentación",
        "DevicePacked": "Dispositivo empaquetado",
                // test
        "DeviceTestedSuccessfully":"Dispositivo probado - con éxito",
        "DeviceMovedToRepair":"Dispositivo movido a reparación",
        "DeviceMovedToAtRepairO2matic":"Dispositivo movido a reparación en O2matic",


        "NewValue": "Nuevo valor",
        "average": "promedio",
        "QRScanner": "Escáner QR",
        "UnderInvestigation": "Bajo investigación",
        "UnderInvestigationMessage": "Selecciona el dispositivo bajo investigación para el próximo paso",
        "QRscannerText": "Escanear el código QR en la parte posterior de un dispositivo PRO o HOT para ver y editar la información del dispositivo.",
        "InvestigateDeviceWithUdsn": "Investigar dispositivo con UDSN",
        
        "Parameter": "Parámetro",
        "Severity": "Gravedad",
        "Description": "Descripción",
        "Statistics": "Estadísticas",
        "DisclaimerDataVal": "AvisoLegal: Los datos no están validados y no deben usarse para evaluar la condición de un paciente.",
        "ProfileName": "Nombre de perfil",
        "Delay": "Retraso",
        "Sec": "Seg",
        "sec": "seg",
        "min": "min",
        "Min": "Min",
        "Max": "Máx",
        "DragNDropFile": "Arrastra y suelta algunos archivos aquí, o haz clic para seleccionar archivos.",
        "Field1": "Campo 1",
        "Field2": "Campo 2",
        "Duration": "Duración",
        "PulseHigh": "Pulso alto",
        "Clear": "Limpiar",
        "QrCode": "Código QR",
        "QrCodeError": "Error de código QR",

        "SuperAdmin": "Super Administrador",

        "Information": "Información",

        "Webpage": "Página web",


        "DeviceLog": "Registros de dispositivo",

        "Info": "Info",
        "Prescribed": "Prescrito",
        "Installed": "Instalado",

        "AnalysingPhase": "Fase de análisis",
        "AnalysingPhaseDuration(s)": "Duración de la fase de análisis (s)",

        //"POComplianceGoal": "Objetivo de PO ////",

        "O2ComplianceGoal": "Objetivo de cumplimiento de O2",


        "O2FlowRanges": "Rango de flujo de O2",
        "WithoutPO": "Sin el oxímetro de pulso",
        "WithPO": "Con el oxímetro de pulso",
        "DeviceSn": "SN del dispositivo",
        "DeviceSerialNumber": "Número de serie del dispositivo",

        "NewPreviewChartDescription1": "El gráfico muestra una descripción general de las 50 sesiones en cada página de la tabla anterior. Para cambiar qué 50 sesiones se visualizan, use las flechas en la parte inferior de la tabla para cambiar la página.",
        "NewPreviewChartDescription2": "Las líneas rojas indican el rango objetivo de SpO2 del perfil de tratamiento, mientras que un punto anaranjado indica un cambio de perfil de tratamiento.", // treatment -> session
        "NoData": "Sin datos",
        "NoRows": "Sin filas",
        "Year": "Año",
        "Years": "Años",
        "years": "años",
        "Month": "Mes",
        "SessionInformation": "Información de la sesión",
        "DeviceAssignedToPatient": "Dispositivo asignado al paciente",
        "LatestReceivedDeviceLog": "Último registro recibido del dispositivo",
        //"LastTreatmentTime": "Hora de la última sesión",
        //"NextTreatmentTime": "Hora de la próxima sesión",
        "Pending": "Pendiente",
        "PendingInstallation": "Instalación pendiente",
        "PreviousTreatmentInformation": "Información de tratamiento previo",
        "CurrentTreatmentOnDevice": "Tratamiento actual en el dispositivo:",
        "CurrentTreatmentOnDeviceDescription": "El tratamiento prescrito recientemente aún no se ha instalado en el dispositivo del paciente. A continuación se muestra el perfil de tratamiento actual en el dispositivo del paciente. Para que el nuevo tratamiento se instale en el dispositivo del paciente, informe al proveedor de servicios que el tratamiento debe actualizarse en la próxima visita al paciente.",
        "InstallationOfTreatmentPending": "Instalación de tratamiento pendiente",
        "UDSN": "UDSN",
        "PUID": "PUID",
        "MAC": "MAC",
        "DeviceOwner": "Propietario del dispositivo",
        "DeviceLocation": "Ubicación del dispositivo",
        "Location": "Ubicación",
        "ReleaseNotes": "Notas de lanzamiento",
        "ContactInformation": "Información del contacto",
        //"Lod1DurationExplanation": "Establézcalo en Sí si no desea que los primeros 5 minutos de un tratamiento ajusten automáticamente el flujo",

        
        "DeviceInformation": "Información del dispositivo",
        "PatientO2maticId": "Identificación O2matic del paciente",
        "PulseBpm": "Pulso (bpm)",
        "RegExpEmoji":"El campo de texto no puede incluir pictogramas ni emojis.",
        "TemplateId": "Identificación de plantilla",
        "LocationId": "Identificación de ubicación",
        "LocationName": "Nombre de ubicación",
        "LocalTime": "Hora local",
        "LocalTimestamp": "Marca de tiempo local",
        "UnixTimestamp": "Marca de tiempo unix",
        "Timestamp": "marca de tiempo",
        "TimestampVal": "marca de tiempo: %{time}",
        "SpO2RangeMax": "Rango máximo de SpO2",
        "SpO2RangeMin": "Rango mínimo de SpO2",
        "O2RangeMaxWith": "Rango máximo de O2 con oxímetro de pulso",
        "O2RangeMinWith": "Rango mínimo de O2 con oxímetro de pulso",
        "O2RangeMaxWithout": "Rango máximo de O2 sin oxímetro de pulso",
        "O2RangeMinWithout": "Rango mínimo de O2 sin oxímetro de pulso",
        "O2RangeWithoutPOExplanation": "Rango de flujo de O2 en l/min cuando el oxímetro de pulso NO está en el dedo",
        "O2RangeWithoutPO": "Rango de flujo de O2 sin oxímetro de pulso",
        "O2RangeWithPO": "Rango de flujo de O2 con oxímetro de pulso",
        "DetailedDataDescription": "Haga clic y arrastre el cursor para ampliar. Haga doble clic para volver a la vista completa.",
        "TreatmentChanged": "Tratamiento cambiado",
        "UserName": "Nombre de usuario",

        "AnalysingPhaseExplanationPatientPage": "Si la Fase de Análisis está configurada en Sí, el paciente continuará recibiendo un flujo fijo de O2 durante los primeros 5 minutos después de colocarse el oxímetro de pulso.",
        "AnalysingPhaseExplanationTreatmentPage": "Establezca en sí si el paciente debe recibir un flujo fijo de O2 durante los primeros 5 minutos después de colocarse el oxímetro de pulso.",
        "FlowResponseExplanation": "La respuesta del flujo determina qué tan rápido se ajusta hacia arriba o hacia abajo el flujo de oxígeno por el dispositivo.",
        "AllowedTimeWithinExplanation": "Número de minutos por hora con el flujo de O2 más alto/más bajo incluso cuando el paciente usa un oxímetro de pulso.",
        "OxygenComplianceGoalExplanationPatientPage": "El número mínimo de horas por día que se espera que el paciente reciba terapia de oxígeno a través del dispositivo.",
        "OxygenComplianceGoalExplanationTreatmentPage": "Por favor, especifique el número mínimo de horas por día que se espera que el paciente reciba terapia de oxígeno a través del dispositivo.",
        "WithPulseOximeterExplanation": "El rango de flujo de O2 en l/min cuando el paciente lleva puesto el oxímetro de pulso",
        "WithoutPulseOximeterExplanation": "El rango de flujo de O2 en l/min cuando el paciente NO lleva puesto el oxímetro de pulso",
        "withPulseOximeterOn": "con el oxímetro de pulso encendido",

        "ReportGenerated": "Informe generado",
        
        "PersonalInformation": "Informacion personal",
        "SessionsOverview": "Resumen de sesiones",
        "Last7days": "Los últimos 7 días",
        "Last14days": "Los últimos 14 días",
        "ofComplianceGoal": "de la meta de cumplimiento",
        "*empty*": "*vacío*",
        "ComplianceGoalLegendPercent": "Porcentaje de objetivo de cumplimiento diario de oxígeno alcanzado:",
        "ComplianceGoalLegendHours": "Número de horas de uso activo diario de oxígeno:",


        "HoursOfUseUnverified": "Horas de uso no verificadas",
        "2HoursOfUnverifiedUse": "2 horas de uso no verificado",
        "2HoursOfVerifiedUse": "2 hours of verified use",

        "DownloadAllSessionsAsCsv": "Descargar todas las sesiones como csv",
        "Administrator": "Administrador",
        "AdministratorDescription": "Puede crear, editar y ver 'Ubicaciones', crear, ver y eliminar 'Licencias' y crear, editar, ver y eliminar 'Usuarios'.",
        "Auditor": "Auditor",
        "AuditorDescription": "Puede ver el 'Registro' de acciones realizadas por los usuarios.",
        "TreatmentTemplateManager": "Gestor de Plantillas de Tratamiento",
        "TreatmentTemplateManagerDescription": "Puede crear y ver 'Tratamientos'.",
        "DeviceManager": "Gestor de Dispositivos",
        "DeviceManagerDescription": "Puede crear, editar y ver 'Dispositivos' y registros de dispositivos y crear, ver y eliminar 'Licencias'.",
        "DeviceMonitor": "Monitor de Dispositivos",
        "DeviceMonitorDescription": "Puede ver 'Dispositivos' y registros de dispositivos.",
        "PatientMonitor": "Monitor de Pacientes",
        "PatientMonitorDescription": "Puede ver 'Pacientes'.",
        "PatientManager": "Gestor de Pacientes",
        "PatientManagerDescription": "Puede crear, editar y ver 'Pacientes'.",
        "Assembler": "Ensamblador",
        "AssemblerDescription": "Puede crear nuevos lotes, crear nuevos dispositivos y agregar componentes a dispositivos.",
        "Tester": "Probador",
        "TesterDescription": "Puede ver los dispositivos listos para ser probados y aprobar pruebas de dispositivos.",
        "Packager": "Empaquetador",
        "PackagerDescription": "Puede empaquetar y aprobar que todos los elementos estén en la caja antes del envío.",
        "ProductionQa": "QA de Producción",
        "ProductionQaDescription": "Puede aprobar dispositivos y/o lotes.",
        "Shipper": "Transportista",
        "ShipperDescription": "Puede cambiar el propietario y la ubicación a la ubicación de envío.",
        "Repairer": "Reparador",
        "RepairerDescription":  "Puede establecer el dispositivo como bajo investigación o en reparación.",
        "CtManager": "Gestor de CT",
        "CtManagerDescription":  "Puede cambiar los parámetros de ubicación para ensayos clínicos (flujo máximo de O2 y período de retención de datos).",
        "O2maticQa": "QA de O2matic",
        "O2maticQaDescription": "Puede aprobar lotes.",
        "O2maticAdministator": "Administrador de O2matic",
        "O2maticAdministatorDescription": "Puede agregar y cambiar notificaciones de página, opciones de metadatos de dispositivos y oxímetros de pulso en la lista blanca.",
        "O2maticTester": "Probador de O2matic",
        "O2maticTesterDescription": "Puede ver los dispositivos listos para pruebas por O2matic y aprobar las pruebas de los dispositivos.",

        "InstallerTablet": "Tableta de instalación",
        "InstallerTabletDescription": "Puede instalar un paciente y su perfil de tratamiento en un dispositivo HOT y enviar datos de sesión. Esta licencia también puede actualizar y restablecer a los valores de fábrica los dispositivos HOT.",
        "PatientTablet": "Tableta de paciente",
        "PatientTabletDescription": "Puede enviar y ver las últimas sesiones y monitorear las mediciones actuales de datos de SpO2, pulso y flujo de O2 del paciente.",
        "DetailedSessionSender": "Remitente de sesión detallada",
        "DetailedSessionSenderDescription": "Una licencia adicional para permitir que la tableta envíe datos detallados.",

        "EditRoles": "Editar roles",
        "SaveRoles": "Suardar roles",
        "Save": "Guardar",
        "DeleteUser": "Borrar usuario",

        "ListOfO2maticUsers": "Lista de usuarios de O2matic",
        "Date": "Fecha",
        "Dates": "Fechas",
        "Signature": "Firma",
        "ListDownloaded":"Lista de usuarios de O2matic descargados en:",
        "RolesApprovedBy":"Los roles de todos los usuarios de O2matic están aprobados por:",
        "DownloadAsPdf": "Descargar como pdf",
        "Downloaded": "Descargado",

        "PRO": "PRO",
        "HOT": "HOT",

        "DailyReport": "Reporte diario",
        "NoDetailedSessionData": "Unable to fetch day data",
        "MultipleDayReport": "Informe de varios días",
        "MultipleDayReportDescription": "Use los seleccionadores de fecha para elegir un rango de un máximo de 5 días y generar un informe de varios días",
        "DailyReportsAndSessions": "Reporte diarios y sesiones",
        "DailyReportsAndSessionsDescription": "Aquí puedes encontrar reporte diarios y sesiones dentro del período de tiempo seleccionado.",
        "Data": "Datos",
        "DataArchive": "Archivo de datos",
        "DataTableDescription": "Haga clic en una fila para abrir el archivo o use las casillas de verificación para seleccionar los archivos para descargar.",
        "FilesToBeDownloaded": "Archivos a descargar",
        "ConfirmDownload": "Confirmar descarga",
        "PdfDisclaimer": "Descargar datos como archivos PDF generará un archivo PDF para cada informe diario dentro del marco de tiempo seleccionado.",        
        "CsvDisclaimer": "Descargar datos como un archivo CSV generará un solo archivo CSV que contiene todos los datos dentro del marco de tiempo seleccionado.",
        "ConfirmToDownloadCsv": "Confirmar para descargar 1 archivo CSV combinado con datos desde %{from} - %{to}",
        "ConfirmToDownloadPdf": "Confirme el deseo de descargar %{totalFiles} archivos PDF individuales",
        "FailedToFetch": "No se puede obtener los datos de la sesión: código de estado %{statusCode}",
        "DataRate": "Tasa de datos de cada %{rate} fila",
        "DataRateExplainer": "Seleccione cuántos datos se deben descargar por cada segundo de datos. Una tasa de datos que resulte en más de 1.000.000 de filas en el archivo no estará disponible para selección.",  // For example, if you select 'Data from every 2nd second', the data will be downloaded for every 2nd second of data
        "PdfFile": "Archivo PDF",
        "CsvFile": "Archivo CSV",


        "ViewLiveData":"Ver datos en vivo",
        "ShowDataFor:": "Mostrar datos de:",
        "EntireDay": "Todo el día",

        "ProReportGenerator": "Generador de informes PRO",

        "ProfileSettings": "Configuración de perfil",
        "locationsDoNotMatch": "las ubicaciones no coinciden",

        
        "UpdatesBanner": "Actualizaciones - Haga clic para ver una descripción de las nuevas funciones y cambios en esta página",
        "UpdatesHeader": "Actualizaciones - Aquí hay una descripción de algunas de las nuevas funciones y cambios",
        "UpdatesLine1": "Para obtener una visión general de todas las nuevas funciones y cambios de la última versión, consulte las notas de la versión que se encuentran en la página de 'Información'.",
        "UpdatesLine2": "Nuevas funciones en esta página:",
        "UpdatesDescriptionInformationPage": "Esta página es una nueva función y sirve para mantener información de contacto general, las últimas notas de la versión del Portal O2matic junto con instrucciones y guías para el Portal O2matic y para el dispositivo HOT.",
        "UpdatesDescriptionPROPage": "Esta página tiene un nuevo diseño, pero contiene la misma información que antes, y 'Registro de Eventos' ahora se llama 'Registro de Dispositivo'.",
        "UpdatesDescriptionHOTPage": "Este 'Registro del dispositivo' se ha actualizado para contener más registros de eventos. La gravedad de los eventos ahora es baja, media y alta, y se puede usar para filtrar los registros. Los selectores de fecha se pueden usar para obtener registros de un período de tiempo específico.",
        "UpdatesDescriptionDevicesPage": "Esta página contiene acceso al escáner QR del dispositivo, páginas de dispositivos HOT y dispositivos PRO.",
        "UpdatesDescriptionPatientPage": "Esta página tiene un nuevo diseño donde toda la información relacionada con el paciente se reúne en el cuadro azul más a la izquierda, toda la información relacionada con el tratamiento está en el más a la derecha y la información técnica y del dispositivo está en el cuadro azul inferior. NUEVO: Ahora hay una marca de tiempo prescrita para el tratamiento, que es cuando se ha hecho el último cambio en el tratamiento. NUEVO: El estado del tratamiento indica si el tratamiento ha sido instalado en el dispositivo HOT o no. Si el tratamiento ha sido instalado, se mostrará la marca de tiempo de la instalación, de lo contrario, el estado de la instalación dirá 'Pendiente'. NUEVO: Si la ubicación del paciente y el dispositivo no coinciden, se mostrará 'Desajuste de Ubicación' junto a la ubicación del dispositivo y el nombre de la ubicación del dispositivo HOT y del paciente será naranja. Las ubicaciones deben coincidir para asegurar la transferencia correcta de datos, lo que se hace cambiando la ubicación del paciente o contactando a un usuario con el rol de 'Administrador de Dispositivos' para actualizar la ubicación del dispositivo HOT. NUEVO: En el cuadro azul de información del dispositivo ahora se incluye la marca de tiempo de cuando el dispositivo se asignó inicialmente al paciente, el último registro de dispositivo recibido, la marca de tiempo de la última sesión y el tiempo hasta que se deba realizar la próxima sesión. Los diseños de los gráficos se han actualizado (una guía para leer los gráficos se puede encontrar en el 'Manual del Portal' en la página de 'Información'). El gráfico de resumen de sesiones estaba anteriormente ubicado dentro de una pestaña en la página, pero ahora se muestra en la parte superior de la página para facilitar el acceso. La pestaña anterior 'Sesiones' ahora se llama 'Archivo de datos' y contiene tanto informes de sesiones como informes diarios (para descripciones de los dos tipos de informes, consulte el 'Manual del Portal'). La función de 'Datos en vivo' se ha movido a la parte superior de la página dentro del cuadro azul del paciente (consulte el 'Manual del Portal' para la descripción de la función de datos en vivo).",
        "UpdatesDescriptionPatientsPage": "Esta página ahora contiene una mejor función de búsqueda, donde puede buscar pacientes por ID de O2matic, Valor de Identificación, Nombre, Fecha de nacimiento y Ubicación. Buscar por Ubicación le proporcionará una tabla de todos los pacientes en esa ubicación.",
        "UpdatesDescriptionUsersPage": "Esta página ahora contiene una mejor función de búsqueda, donde puede buscar usuarios por ID, Nombre, Apellido, Correo electrónico, Ubicación del usuario y roles específicos. Al hacer clic en el botón de búsqueda sin completar ningún criterio de búsqueda, se le proporcionará una tabla de todos los usuarios.",
        "UpdatesDescriptionUserPage": "Esta página tiene un nuevo diseño y una mejor vista general de los roles y las ubicaciones correspondientes del usuario. Al hacer clic en 'Editar roles', puede agregar/eliminar roles, agregar roles a nuevas ubicaciones o eliminar al usuario.",
        "UpdatesDescriptionQRScannerPage": "Esta es una nueva página donde puede escanear el código QR en la parte posterior de un dispositivo PRO o HOT para ver y editar la información del dispositivo.",
        "UpdatesDescriptionTreatmentPage": "La página de tratamiento ha tenido una reformulación de los parámetros de tratamiento pero contiene los mismos parámetros que antes.",
        "UpdatesDescriptionTreatmentCreatePage": "La página de creación de tratamiento ha sido reformulada en cuanto a los parámetros del tratamiento, pero contiene los mismos parámetros que antes.",
        "UpdatesDescriptionLogsPage": "Esta página ahora contiene selectores de fechas para seleccionar un intervalo de tiempo específico para ver los registros. Los registros también se pueden descargar como un archivo CSV, pero cualquier filtro aplicado a la tabla no se aplicará en los archivos CSV.",
        "UpdatesDescriptionAppLicensePage": "Esta página tiene un nuevo diseño, pero contiene la misma información que antes.",
        "UpdatesDescriptionLocationPage": "Esta página tiene un nuevo diseño, pero contiene la misma información que antes.",
        "UpdatesDescriptionPatientCreatePage": "La parte del tratamiento de esta página ha tenido una reformulación de los parámetros de tratamiento pero contiene los mismos parámetros que antes.",
        "UpdatesDescriptionPatientEditPage": "La parte del tratamiento de esta página ha tenido una reformulación de los parámetros de tratamiento pero contiene los mismos parámetros que antes.",
        "UpdatesDescriptionInstallerPage": "Esta nueva página le muestra una visión general de los pacientes y dispositivos, y si se requiere alguna acción relacionada con el servicio. Ejemplos de actividades relacionadas con el servicio son pacientes que han recibido un nuevo perfil de tratamiento o un dispositivo que necesita una actualización de software.",

        

        "UserManual":"Manual de usuario",
        "TechnicalManual": "Manual técnico",

        "InstructionsAndGuides": "Instrucciones y guías",
        "InstructionsDescription": "Haga clic en el idioma en el que desea ver la instrucción o guía. El archivo se abrirá como un PDF en una nueva ventana. Para otras versiones y para instrucciones de dispositivos PRO, por favor visite www.o2matic.com.",
        "ForO2maticHotAppSee": "Para la aplicación 'O2matic - HOT', consulte",

        "RepairProdDescription": "Seleccione el dispositivo a reparar durante la producción.",
        "RepairO2maticDescription": "Seleccione el dispositivo a reparar por O2matic.",

        "DetailedSessionData": "Datos detallados de la sesión",
        "TreatmentProfileDetails": "etalles del perfil de tratamiento",
        "LastSessionTime": "Hora de la última sesión",
        "NextSessionTime": "Hora de la próxima sesión",
        "Last":"Último",

        "Remark": "Comentario",
        "Remarks": "Comentarios",
        "NumberOfDevices": "Número de dispositivos",

        "NoResults": "El filtrado no devuelve resultados.",
        "NoRowsOximeters": "No se encontraron oxímetros.",
        "NoRowsMetadata": "No se encontró metadata.",
        "NoRowsPatients": "No se encontraron pacientes.",
        "NoRowsTreatments": "No se encontraron perfiles de tratamiento.",
        "NoRowsLicenses": "No se encontraron licencias.",
        "NoRowsLocations": "No se encontraron ubicaciones.",
        "NoRowsUsers": "No se encontraron usuarios.",
        "NoRowsDevices": "No se encontraron dispositivos.",
        "NoRowsLogs": "No se encontraron registros.",
        "TestProtocolIdentifierText": "Introduzca el identificador del documento de prueba. (Normalmente con el formato D x.y.z)",

        "InstallerSearch": "Buscar pacientes y dispositivos utilizando uno o más de los criterios de búsqueda a continuación",

        // PRO REPORT
        "ProReport": "Informe PRO",
        "CreateProReport": "Crear informe PRO",
        "ProReportMessage": "Sube archivos de sesiones PRO y genera el informe. No se guarda ni transfiere ningún dato.",

        // DOWNLOAD ANONYMIZED DATA
        "Anonymized":"Anónimo",
        "AnonymizedPatientId":"Identificación anonimizada del paciente",
        "AnonymizedSessionData":"Datos de sesión anonimizados",

        //Enviornments 
	"development": "Development",
	"training": "Entrenamiento",
	"local": "Local",
	"staging": "Staging",


        "IBackupFlow": {
                "Explainer": {
                        "TreatmentPage": "Introduzca el flujo que el paciente debe usar en una emergencia, como un corte de energía o problemas técnicos con la fuente de oxígeno o el dispositivo HOT. El flujo de respaldo debe estar a un nivel que proporcione al paciente el tratamiento de oxígeno necesario hasta que el proveedor de servicios pueda asistirle.",
                        "PatientPage": "El flujo de oxígeno de respaldo independiente del HOT que el paciente debe usar en una emergencia, como un corte de energía o problemas técnicos con la fuente de oxígeno o el dispositivo HOT. El flujo de respaldo debe proporcionar al paciente el tratamiento de oxígeno necesario hasta que el proveedor de servicios pueda asistirle."
                }
        },
        "IndependentBackupFlow": "Flujo de oxígeno de respaldo independiente del HOT",
        "IndependentBackupFlowO2": "Flujo de O2 de respaldo independiente del HOT",
        "UsedProtocol": "Protocolo utilizado",
        "LatestTestResult": "Último resultado de prueba",
    },
        //DEVICE TEST 
        "FileName": "%{fileName}",
        "UploadTraceProtocol": "Subir Protocolo de Trace",
        "UploadTraceProtocolHeader": "Subir Protocolo de Trace",
        "UploadTraceProtocolExplainer": "Sube el archivo de protocolo a la nube y añade los metadatos si es necesario.",
        "SelectFile": "Seleccionar archivo para subir",
        "SelectProtocolType": "Seleccionar tipo de protocolo",
        "SelectProtocolScope": "Seleccionar alcance del protocolo",
        "SelectDeviceType": "Seleccionar tipo de dispositivo",
        "TestCaseCount": "Cantidad de casos de prueba",
        "UploadFile": "Subir archivo",
        "TestCaseCountError": "Se requiere la cantidad de casos de prueba",
        "TestEquipmentCountError": "Se requiere la cantidad de equipos de prueba",
        "SelectTestProtocol": "Seleccionar protocolo de prueba",
        "CheckDocumentId": "Verifica que el protocolo de prueba seleccionado sea la última versión proporcionada por O2matic.",
        "Passed": "Aprobado",
        "Failed": "Reprobado",
        "ResultValue": "Valor del resultado",
        "isRequired": "Se requiere %{value}",
        "TestCase": "Caso de prueba",
        "TestCaseId": "Caso de prueba %{id}",
        "TestResultDialogUser": "Usuario: %{username} (%{userId})",
        "TestProtocol": "Protocolo de prueba",
        "ServiceProtocol": "Protocolo de servicio",
        "TestProtocolName": "Protocolo de prueba: %{tpName}",
        "EquipmentUsed": "EquipmentUsed: Equipo utilizado durante la prueba",
        "AddEquipment": "Agregar equipo",
        "EquipmentTypeId": "EQ ID",
        "EquipmentId": "ID",
        "EquipmentTypeIdValue": "EQ ID: %{value}",
        "EquipmentIdValue": "ID: %{value}",
        "EquipmentTypeIsRequired": "Se requiere el tipo de equipo",
        "EquipmentIdIsRequired": "Se requiere el ID del equipo",
        "EquipmentInfoNotVaild": "Falta información del equipo",
        "SelectServiceProtocol": "Seleccionar protocolo de servicio",
        "CheckServiceProtocolId": "Verifica que el protocolo de servicio seleccionado sea la última versión proporcionada por O2matic.",
        "TestEquipmentCount": "Cantidad de equipos de prueba",
        "ContainsLabels": "Etiqueta de paquete",
        "PackageContainsLabels": "El paquete tiene etiqueta",

}
export default Spanish;
